import { useCallback, useState } from 'react';
import { useGetList } from 'react-admin';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

interface CustomPropsInterface {
  customRowsPerPage?: number;
  sort?: SortInterface;
  filter?: GenericObject;
}

interface SortInterface {
  field: string;
  order: string;
}

export const useGenericList = (resource: string, customProps?: CustomPropsInterface) => {
  const [filters, setFilters] = useState(customProps?.filter ?? {});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(customProps?.customRowsPerPage ?? 10);
  const [sort, setSort] = useState<SortInterface>(customProps?.sort ?? { field: 'id', order: 'ASC' });

  const { isLoading, data, total } = useGetList(resource, {
    pagination: { page: page + 1, perPage: rowsPerPage + 1 },
    filter: filters,
    sort: sort,
  });

  const handleChangePage = useCallback((event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    setPage(newPage);
  }, []);

  const handleChangeSort = useCallback((newSort: SortInterface) => {
    setSort(newSort);
  }, []);

  const handleChangeRowsPerPage = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
  }, []);

  const handleChangeFilters = useCallback((newFilters: GenericObject) => {
    setFilters({ ...newFilters });
    setPage(0);
  }, []);

  return {
    isLoading,
    filters,
    sort,
    data,
    total,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    handleChangeFilters,
    handleChangeSort,
  };
};
